export default __webpack_public_path__ + "static/media/image00030.da8db572.jpeg";